import React from 'react';
import './styles.scss';

const TabButtons = ({ tabs, activeIndex, onTabChange, buttonSize = 'sm', wrapperClassName = '' }: TabButtonsProps) => {
  return (
    <div className={`tabs d-flex ${wrapperClassName}`}>
      {tabs.map((tab, index) => {
        const isActive = index === activeIndex;
        const buttonClass = isActive ? `button-primary-${buttonSize}` : `button-ghost-${buttonSize}`;

        return (
          <button key={tab.key} type="button" className={`tab ${buttonClass}`} onClick={() => onTabChange(index)}>
            {tab.title}
          </button>
        );
      })}
    </div>
  );
};

export default TabButtons;

export interface TabItem {
  key: string;
  title: string;
}

interface TabButtonsProps {
  tabs: TabItem[];
  activeIndex: number;
  onTabChange: (index: number) => void;
  buttonSize?: 'xs' | 'sm' | 'md';
  wrapperClassName?: string;
}
